import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class InviteMemberDataService {
  //private subject = new Subject<Object>();
  private subject = [];

  constructor() { }

  sendData(data) {
    //this.subject.next(data);
    this.subject = data;
  }
  
  //getData(): Observable<Object> {
  //  return this.subject.asObservable();
  //}
  getData() {
    return this.subject;
  }

  clearData() {
    //this.subject.next();
    this.subject = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/invite-member-data.service.ts